import Vue from 'vue'
import Vuex from 'vuex'
const baseUrl = process.env.VUE_APP_WEBAPI_URL;

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    profile: null,
    isLoggedIn: false,
    cognitoUsername: null,
    customerId: null,
    customerName: null,
    baseUrl,
    customer: null,
    loading: false
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile;
    },
    setCustomer(state, customer) {
      state.customer = customer;
    },
    setCustomerId(state, customerId) {
      state.customerId = customerId;
    },
    setCustomerName(state, customerName) {
      state.customerName = customerName;
    },
    setIsUserLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setCognitoUsername(state, cognitoUsername) {
      state.cognitoUsername = cognitoUsername;
    },
    setWebsocket(state, websocket) {
      state.websocket = websocket;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    signOut(context) {
      context.commit("setIsUserLoggedIn", false);
      context.commit("setCognitoUsername", null);
      context.commit("setProfile", null);
    }
  },
  modules: {
  },
  getters: {

  }
})
